module.exports = __webpack_public_path__ + "static/bringing-soldiers-home-0fbf53be205c5526f4e50ea030375ded.jpg";